import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Switch,
  FormControlLabel,
  Box,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";
import { useHierarchy } from "context/HierarchyContext";

function AdminUnitsPopupForm({
  onClose,
  mode,
  unit,
  propertyId,
  refreshUnits,
}) {
  const [form, setForm] = useState({
    name: "",
    description: "",
    unit_code: "",
    active: true,
  });
  
  const [loading, setLoading] = useState(false);
  const { orgId } = useHierarchy();

  useEffect(() => {
    if (mode === "edit" && unit) {
      setForm({
        name: unit.name || "",
        description: unit.description || "",
        unit_code: unit.unit_code || "",
        active: unit.active ?? true,
      });
    }
  }, [mode, unit]);

  const handleChange = (field, value) => {
    const newValue = field === "unit_code" ? value.toUpperCase() : value;
    setForm((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const code = form.unit_code.trim().toUpperCase();

    const unitCodeRegex = /^(?!.*-.*-)[A-Z0-9-]/;

    if (!unitCodeRegex.test(code)) {
      showWarning("Unit code must be 6 characters, can include letters, numbers, and at most one hyphen.");
      return;
    }

    const payload = {
      name: form.name.trim(),
      description: form.description.trim(),
      unit_code: code,
      // active: form.active,
      property_id: Number(propertyId),
      organization_id: orgId || null,
    };

    try {
      setLoading(true);

      // API CALLS LEFT EXACTLY AS YOU HAD THEM
      if (mode === "create") {
        await api.unit.createUnit(payload);
        showSuccess("Unit Created Successfully.");
      } else {
        await api.unit.updateUnitDetails(unit.id, payload);
        showSuccess("Unit Updated Successfully.");
      }

      refreshUnits();
      onClose();
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {mode === "create" ? "Create Unit" : "Edit Unit"}
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2}>
            <Field
              label="Unit Name"
              value={form.name}
              onChange={(v) => handleChange("name", v)}
              required
            />

            <Field
              label="Unit Code (EX: ABC-12, ABC123, ABC-1A)"
              value={form.unit_code}
              onChange={(v) => handleChange("unit_code", v)}
              required
              inputProps={{ maxLength: 6 }}
            />

            <Field
              label="Description"
              value={form.description}
              onChange={(v) => handleChange("description", v)}
              fullWidth
            />

            {/* {mode === "edit" && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.active}
                      onChange={(e) =>
                        handleChange("active", e.target.checked)
                      }
                    />
                  }
                  label="Active Unit"
                />
              </Grid>
            )} */}
          </Grid>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

function Field({ label, value, onChange, fullWidth, required, inputProps }) {
  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <SoftTypography variant="caption" fontWeight="bold">
        {label}
        {required && (
          <Box component="span" color="error.main">
            {" "}
            *
          </Box>
        )}
      </SoftTypography>

      <SoftInput
        placeholder={`Enter ${label}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        inputProps={inputProps}
      />
    </Grid>
  );
}

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  inputProps: PropTypes.object,
};

AdminUnitsPopupForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(["create", "edit"]).isRequired,
  unit: PropTypes.object,
  propertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  refreshUnits: PropTypes.func.isRequired,
};

export default AdminUnitsPopupForm;